"use strict";

var _interopRequireDefault = require("E:/WebProject/\u684C\u9762/JY-SSO/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("E:/WebProject/\u684C\u9762/JY-SSO/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _objectSpread2 = _interopRequireDefault(require("E:/WebProject/\u684C\u9762/JY-SSO/node_modules/@babel/runtime/helpers/objectSpread2.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("E:/WebProject/\u684C\u9762/JY-SSO/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.array.find");
var _components = require("@/components");
var _user = require("@/api/data/user");
var _role = require("@/api/data/role");
var _jsMd = _interopRequireDefault(require("js-md5"));
var _validate = require("@/utils/validate");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'User',
  components: {
    PageInfo: _components.PageInfo
  },
  data: function data() {
    var validateByEmail = function validateByEmail(rule, value, callback) {
      if (!value) {
        return callback(new Error('请输入邮箱'));
      }
      if (!(0, _validate.checkEmail)(value)) {
        return callback(new Error('请输入正确格式的邮箱'));
      } else {
        callback();
      }
    };
    return {
      pagination: {
        page: 1,
        limit: 20,
        total: 100
      },
      querySelectOptions: [],
      searchForm: {
        app_name: undefined,
        state: undefined,
        role_ids: null,
        is_sup: null,
        is_pitcher: null,
        is_designer: null
      },
      dialogVisible: false,
      listData: [],
      isEdit: false,
      dataForm: {
        app_name: '',
        app_domain: '',
        state: '',
        app_secret: '',
        des: ''
      },
      rules: {
        app_name: [{
          required: true,
          message: '请输入应用名称',
          trigger: 'blur'
        }],
        app_domain: [{
          required: true,
          message: '请输入应用域名',
          trigger: 'blur'
        }],
        state: [{
          required: true,
          message: '请输入状态',
          trigger: 'blur'
        }],
        des: [{
          required: true,
          message: '请输入描述',
          trigger: 'blur'
        }],
        email: [{
          validator: validateByEmail,
          trigger: 'blur'
        }]
      }
    };
  },
  activated: function activated() {
    this.init();
  },
  created: function created() {
    this.init();
  },
  methods: {
    getName: function getName(item, data) {
      return data.find(function (el) {
        return el.id === item;
      }) ? data.find(function (el) {
        return el.id === item;
      }).name : '';
    },
    fetchData: function () {
      var _fetchData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(page) {
        var params, res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (page) this.pagination.page = page;
              params = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.searchForm), this.pagination);
              _context.next = 4;
              return (0, _user.getUserList)(params);
            case 4:
              res = _context.sent;
              this.listData = res.data.list;
              this.pagination.total = res.data.total;
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function fetchData(_x) {
        return _fetchData.apply(this, arguments);
      }
      return fetchData;
    }(),
    /* 初始化相关内容 */init: function () {
      var _init = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.fetchData();
              _context2.next = 3;
              return (0, _role.getRoleSelection)();
            case 3:
              this.querySelectOptions = _context2.sent.data;
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }(),
    addApp: function addApp() {
      this.isEdit = false;
      this.dialogVisible = true;
      this.dataForm = {
        name: '',
        email: '',
        real_name: '',
        newPassword: '',
        is_sup: 0,
        is_pitcher: 0,
        is_designer: 0,
        state: 1,
        mobile: '',
        role_ids: [],
        allow_web_login: 1,
        is_sensitive: 0
      };
    },
    tableEdit: function tableEdit(data) {
      var _this = this;
      this.isEdit = true;
      this.dialogVisible = true;
      (0, _user.getUser)(data.id).then(function (res) {
        _this.dataForm = res.data;
      }).catch(function (err) {
        _this.$message.error(err.msg);
      });
    },
    tableSwitch: function tableSwitch(data) {
      var _this2 = this;
      this.$confirm("\u6B64\u64CD\u4F5C\u5C06".concat(data.state === 1 ? '禁用' : '启用', " ").concat(data.real_name, "-").concat(data.name, " \u8D26\u53F7, \u662F\u5426\u7EE7\u7EED?"), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var params = {
          id: data.id,
          state: data.state === 1 ? 0 : 1
        };
        (0, _user.changeState)(params).then(function (res) {
          _this2.$message.success('操作成功');
          _this2.fetchData();
        }).catch(function (err) {
          _this2.$message.error(err.msg);
        });
      }).catch(function () {
        _this2.$message({
          type: 'info',
          message: '已取消操作'
        });
      });
    },
    onSave: function onSave() {
      var _this3 = this;
      this.$refs['userForm'].validate(function (valid) {
        if (valid) {
          if (!_this3.isEdit) {
            _this3.dataForm.password = (0, _jsMd.default)(_this3.dataForm.newPassword);
            (0, _user.addUser)(_this3.dataForm).then(function (res) {
              _this3.$message.success('添加成功');
              _this3.fetchData();
            }).catch(function (err) {
              _this3.$message.error(err.msg);
            });
          } else {
            if (_this3.dataForm.newPassword) {
              _this3.dataForm.password = (0, _jsMd.default)(_this3.dataForm.newPassword);
              console.warn('更改了密码', _this3.dataForm.password);
            }
            (0, _user.updateUser)(_this3.dataForm).then(function (res) {
              _this3.$message.success('编辑成功');
              _this3.fetchData();
            }).catch(function (err) {
              _this3.$message.error(err.msg);
            });
          }
          _this3.dialogVisible = false;
        } else {
          return;
        }
      });
    },
    resetForm: function resetForm() {
      this.$refs['userForm'].resetFields();
      this.dialogVisible = false;
    },
    /* 处理每页展示的数量改变事件 */handlePageSizeChange: function handlePageSizeChange(limit) {
      this.pagination.limit = limit;
      this.pagination.page = 1;
      // 重新加载表格数据
      this.fetchData();
    },
    /* 处理切页 */handlePageChange: function handlePageChange(page) {
      this.pagination.page = page;
      // 重新加载表格数据
      this.fetchData();
    }
  }
};
exports.default = _default;